// @flow

import BaseStorage from "./BaseStorage";
import type Memorizing from "../../models/Memorizing";

const HPM_BOOKMARKS: string = "-hpmbookmarks";

export default class BookmarkStorage extends BaseStorage implements Memorizing<string, ?string> {
	constructor(dealerId: string) {
		super(dealerId, HPM_BOOKMARKS);
	}
}
